exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._home{background-color:#eee}._home .main-icon{background-image:url(" + require("../../../../assets/icons/logo.svg") + ");background-position:50%;background-repeat:no-repeat;background-size:contain;height:200px;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/components/views/home/home.styl
// module id = 414
// module chunks = 0